"use strict";

const SalesConsultants = () => {
    const init = () => {
        $(function() {
            var $consultantsContainer = $('.js-sales-consultants');
            if ($consultantsContainer.length > 0) {
                var $consultants = $consultantsContainer.find('.js-sales-consultant');
                var $dropdowns = $consultantsContainer.find('.js-sales-consultants-dropdown');
                $dropdowns.on('change', function(){
                    var region = $consultantsContainer.find('.js-sales-consultants-dropdown[name="region"]').val();
                    var specialisation = $consultantsContainer.find('.js-sales-consultants-dropdown[name="specialisation"]').val();
                    var filters = '';
                    if(region != ''){
                        filters += '[data-region="'+region+'"]';
                    }
                    if(specialisation != ''){
                        filters += '[data-specialisation*="'+specialisation+'"]';
                    }
                    if(filters != ''){
                        console.log(filters)
                        $consultants.hide();
                        $consultants.filter(filters).show();
                    }else{
                        $consultants.show();
                    }
                });
            }
        });
    };

    return {
        init:init
    };
};

export default SalesConsultants;